import { ClipboardIcon, Monitor01Icon, PlusSquareIcon } from "@vetty/icons";
import { Button, Select } from "@/components";
import {
  POLICY_CATEGORY_FILTER_OPTIONS,
  POLICY_SCOPE_FILTER_OPTIONS,
  type PolicyCategoryFilter,
  type PolicyScopeFilter,
} from "../../_constants/policies-toolbar.const";
import styles from "./PoliciesToolbar.module.scss";

type PoliciesToolbarProps = {
  scope: PolicyScopeFilter;
  category: PolicyCategoryFilter;
  onScopeChange: (value: PolicyScopeFilter) => void;
  onCategoryChange: (value: PolicyCategoryFilter) => void;
  onCreatePolicyClick: () => void;
};

export const PoliciesToolbar = ({
  scope,
  category,
  onScopeChange,
  onCategoryChange,
  onCreatePolicyClick,
}: PoliciesToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={scope}
            startContent={<Monitor01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onScopeChange(value as PolicyScopeFilter)}
          >
            {POLICY_SCOPE_FILTER_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={category}
            startContent={<ClipboardIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onCategoryChange(value as PolicyCategoryFilter)}
          >
            {POLICY_CATEGORY_FILTER_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<PlusSquareIcon style={{ width: 20, height: 20 }} />}
          onClick={onCreatePolicyClick}
        >
          Create profile
        </Button>
      </div>
    </div>
  );
};
